enum TargetType {
    Default,
    NewTab
}

export default TargetType;